(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount"] && !Shopify.designMode) return;
  try {
    class CartDiscount extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-discount-input]');
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-discount-apply]')) this.apply();
        const remove = event.target.closest('[data-discount-remove]');
        if (remove) this.removeCode(remove.dataset.code);
      });
      // On the cart page Enter would submit the cart form (= checkout).
      this.input?.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.apply();
      });
    }

    codes() {
      return (this.dataset.codes || '').split(',').filter(Boolean);
    }

    async apply() {
      const code = this.input.value.trim();
      if (!code) return;
      const current = this.codes();
      if (current.some((c) => c.toLowerCase() === code.toLowerCase())) {
        this.input.value = '';
        return;
      }
      this.showError('');
      const data = await this.send([...current, code]);
      if (!data) return;
      const entry = (data.discount_codes || []).find((c) => c.code.toLowerCase() === code.toLowerCase());
      if (!entry?.applicable) {
        // Take the code off again, so it doesn't linger in the cart.
        await this.send(current, false);
        this.showError(this.dataset.invalid);
        this.input.select();
        return;
      }
      this.done(data);
    }

    async removeCode(code) {
      const data = await this.send(this.codes().filter((c) => c !== code));
      if (data) this.done(data);
    }

    async send(codes, busy = true) {
      const button = busy ? this.querySelector('[data-discount-apply]') : null;
      button?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(','), sections: ['cart-drawer'] }),
        });
        if (!response.ok) throw new Error(response.status);
        return await response.json();
      } catch (error) {
        this.showError(this.dataset.error);
        return null;
      } finally {
        button?.removeAttribute('aria-busy');
      }
    }

    done(data) {
      const drawer = this.closest('cart-drawer');
      if (drawer) {
        drawer.render(data.sections);
        drawer.querySelector('#cart-drawer-content')?.focus({ preventScroll: true });
        return;
      }
      // Cart page: the lines, totals and the drawer all change.
      window.location.reload();
    }

    showError(message) {
      const box = this.querySelector('[data-discount-error]');
      if (!box) return;
      box.textContent = message || '';
      box.hidden = !message;
      if (message) this.querySelector('details').open = true;
    }
  }
  customElements.define('cart-discount', CartDiscount);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["condition-dialog"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      document.getElementById(opener.dataset.dialogOpen)?.showModal();
      return;
    }
    // Any dialog on the page with data-dialog (condition explanation, in3).
    const dialog = event.target.closest('dialog[data-dialog]');
    if (!dialog) return;
    // Close button, or a click on the backdrop (the dialog element itself, outside its content).
    if (event.target.closest('[data-dialog-close]') || event.target === dialog) dialog.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    class CookieBanner extends HTMLElement {
    connectedCallback() {
      this.dialog = document.querySelector('[data-cookie-dialog]');
      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-cookie-settings]')) {
          event.preventDefault();
          this.openSettings();
          return;
        }
        const choice = event.target.closest('[data-cookie-choice]');
        if (choice) this.choose(choice.dataset.cookieChoice);
      });
      if (!window.Shopify?.loadFeatures) return;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error) return;
        this.api = window.Shopify.customerPrivacy;
        // Show while the visitor has not chosen yet (all categories still empty).
        const consent = this.api.currentVisitorConsent?.() || {};
        const undecided = ['analytics', 'marketing', 'preferences'].every((key) => !consent[key]);
        // (shouldShowBanner() keeps answering true after a choice, so it is not used.)
        if (undecided) this.hidden = false;
      });
    }

    openSettings() {
      const consent = this.api?.currentVisitorConsent?.() || {};
      this.dialog.querySelectorAll('[data-cookie-category]').forEach((input) => {
        input.checked = consent[input.dataset.cookieCategory] === 'yes';
      });
      this.dialog.showModal();
    }

    choose(kind) {
      const pick = (key) => {
        if (kind === 'all') return true;
        if (kind === 'none') return false;
        return this.dialog.querySelector(`[data-cookie-category="${key}"]`).checked;
      };
      const consent = {
        analytics: pick('analytics'),
        marketing: pick('marketing'),
        preferences: pick('preferences'),
        sale_of_data: pick('marketing'),
      };
      this.hidden = true;
      if (this.dialog.open) this.dialog.close();
      this.api?.setTrackingConsent(consent, () => {});
    }
  }

  customElements.define('cookie-banner', CookieBanner);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets-panel"] && !Shopify.designMode) return;
  try {
    class FacetPanel extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('dialog');
      this.form = this.querySelector('[data-panel-form]');
      this.submit = this.querySelector('[data-panel-submit]');
      this.reset = this.querySelector('[data-panel-reset]');
      this.params = this.dataset.params.split(',').filter(Boolean);
      this.initialLabel = this.submit.textContent;
      this.panel.addEventListener('click', (event) => {
        if (event.target === this.panel || event.target.closest('[data-panel-close]')) this.panel.close();
      });
      this.panel.addEventListener('close', () => this.restore());
      this.form.addEventListener('input', (event) => {
        if (event.target.matches('[data-panel-search]')) this.search(event.target);
      });
      this.form.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target.matches('[data-panel-search]')) event.preventDefault();
      });
      this.form.addEventListener('change', (event) => {
        if (event.target.matches('input[type="checkbox"], input[type="radio"]')) this.preview();
      });
      this.reset.addEventListener('click', () => {
        this.form.querySelectorAll('input[type="checkbox"]').forEach((box) => (box.checked = false));
        this.form.querySelectorAll('input[type="radio"][value=""]').forEach((radio) => (radio.checked = true));
        this.preview();
      });
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.applyChoice();
      });
    }

    open(opener) {
      const dropdown = this.hasAttribute('data-dropdown') && window.matchMedia('(min-width: 750px)').matches;
      if (dropdown) {
        const rect = opener.getBoundingClientRect();
        const left = Math.min(rect.left, window.innerWidth - 22 * 16 - 16);
        this.panel.style.setProperty('--panel-top', `${rect.bottom + 6}px`);
        this.panel.style.setProperty('--panel-left', `${Math.max(16, left)}px`);
        this.panel.show();
        this.opener = opener;
        this.outside = (event) => {
          if (!this.panel.contains(event.target) && !opener.contains(event.target) && !event.target.closest('dialog[open]:not(.panel)')) this.panel.close();
        };
        this.escape = (event) => {
          if (event.key === 'Escape') this.panel.close();
        };
        this.scroll = () => this.panel.close();
        setTimeout(() => document.addEventListener('click', this.outside));
        document.addEventListener('keydown', this.escape);
        window.addEventListener('scroll', this.scroll, { passive: true, once: true });
        opener.setAttribute('aria-expanded', 'true');
      } else {
        this.panel.showModal();
      }
    }

    // The page URL with this panel's filters replaced by the current choice.
    query() {
      const params = new URLSearchParams(window.location.search);
      this.params.forEach((name) => params.delete(name));
      params.delete('page');
      this.form.querySelectorAll('input[type="checkbox"]:checked').forEach((box) => params.append(box.name, box.value));
      this.form.querySelectorAll('[data-price-params]').forEach((meta) => {
        const radio = this.form.querySelector(`input[name="${meta.dataset.group}"]:checked`);
        if (!radio) return;
        if (Number(radio.dataset.min) > 0) params.set(meta.dataset.minParam, radio.dataset.min);
        if (Number(radio.dataset.max) > 0) params.set(meta.dataset.maxParam, radio.dataset.max);
      });
      return `?${params}`;
    }

    normalize(text) {
      return text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
    }

    search(input) {
      const group = input.closest('.panel__group');
      const term = this.normalize(input.value);
      let visible = 0;
      group.querySelectorAll('[data-panel-item]').forEach((item) => {
        const match = !term || this.normalize(item.textContent).includes(term);
        item.hidden = !match;
        if (match) visible += 1;
      });
      group.querySelector('[data-panel-empty]').hidden = visible > 0;
    }

    // Fetches the section for the current choice, for the count on the button.
    async preview() {
      const search = this.query();
      this.controller?.abort();
      this.controller = new AbortController();
      this.submit.setAttribute('aria-busy', 'true');
      try {
        const params = new URLSearchParams(search);
        params.set('section_id', this.closest('facet-toolbar').dataset.section);
        const response = await fetch(`${window.location.pathname}?${params}`, { signal: this.controller.signal });
        if (!response.ok) throw new Error(response.statusText);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        this.prefetched = { search, doc };
        const label = doc.querySelector(`#${CSS.escape(this.panel.id)} [data-panel-submit]`);
        if (label) this.submit.textContent = label.textContent;
        this.submit.removeAttribute('aria-busy');
      } catch (error) {
        if (error.name !== 'AbortError') this.submit.removeAttribute('aria-busy');
      }
    }

    applyChoice() {
      const search = this.query();
      const doc = this.prefetched?.search === search ? this.prefetched.doc : null;
      this.applying = true;
      this.panel.close();
      this.closest('facet-toolbar').apply(search, true, doc);
    }

    // Closed without applying: back to what the page shows.
    restore() {
      document.removeEventListener('click', this.outside);
      document.removeEventListener('keydown', this.escape);
      window.removeEventListener('scroll', this.scroll);
      this.opener?.setAttribute('aria-expanded', 'false');
      if (this.applying) return;
      this.controller?.abort();
      this.form.reset();
      this.form.querySelectorAll('[data-panel-search]').forEach((input) => {
        input.value = '';
        this.search(input);
      });
      this.submit.textContent = this.initialLabel;
      this.submit.removeAttribute('aria-busy');
    }
  }
  customElements.define('facet-panel', FacetPanel);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-panel-open]');
    if (!opener) return;
    const panel = document.getElementById(opener.dataset.panelOpen)?.closest('facet-panel');
    if (!panel) return;
    event.preventDefault();
    if (panel.querySelector('dialog').open) panel.querySelector('dialog').close();
    else panel.open(opener);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets-toolbar"] && !Shopify.designMode) return;
  try {
    class FacetToolbar extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-toolbar-sort]')) return;
        const params = new URLSearchParams(window.location.search);
        params.set('sort_by', event.target.value);
        params.delete('page');
        this.apply(`?${params}`);
      });
      if (FacetToolbar.listening) return;
      FacetToolbar.listening = true;
      document.addEventListener('click', (event) => {
        const link = event.target.closest('a[data-toolbar-link]');
        const toolbar = document.querySelector('facet-toolbar');
        if (!link || !toolbar) return;
        event.preventDefault();
        toolbar.apply(new URL(link.href, window.location.origin).search);
      });
      window.addEventListener('popstate', () => document.querySelector('facet-toolbar')?.apply(window.location.search, false));
    }

    async apply(search, push = true, prefetched = null) {
      const url = `${window.location.pathname}${search}`;
      const params = new URLSearchParams(search);
      params.set('section_id', this.dataset.section);
      const container = document.getElementById(`results-${this.dataset.section}`);
      container?.setAttribute('aria-busy', 'true');
      try {
        let doc = prefetched;
        if (!doc) {
          const response = await fetch(`${window.location.pathname}?${params}`);
          if (!response.ok) throw new Error(response.statusText);
          doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        }
        const next = doc.getElementById(`results-${this.dataset.section}`);
        if (next && container) container.replaceWith(next);
        if (push) window.history.pushState({}, '', url);
      } catch (error) {
        window.location.href = url;
      }
    }
  }
  customElements.define('facet-toolbar', FacetToolbar);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target.closest('form.newsletter__form');
    if (!form) return;
    const tags = form.querySelector('input[name="contact[tags]"]');
    const topics = [...form.querySelectorAll('[data-topic]:checked')].map((input) => input.value);
    tags.value = [tags.dataset.baseTags, ...topics].join(',');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery {
    constructor(gallery) {
      this.gallery = gallery;
      this.track = gallery.querySelector('.gallery__track');
      this.prev = gallery.querySelector('[data-gallery-prev]');
      this.next = gallery.querySelector('[data-gallery-next]');
      this.index = gallery.querySelector('[data-gallery-index]');
      if (!this.track) return;

      this.prev?.addEventListener('click', () => this.go(this.current() - 1));
      this.next?.addEventListener('click', () => this.go(this.current() + 1));
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.current() - 1);
        else if (event.key === 'ArrowRight') this.go(this.current() + 1);
        else return;
        event.preventDefault();
      });
      gallery.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-thumb]');
        if (!thumb) return;
        const position = this.slides().findIndex((slide) => slide.dataset.mediaId === thumb.dataset.thumb);
        if (position > -1) this.go(position);
      });
      let frame;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => this.sync());
      }, { passive: true });
      new ResizeObserver(() => this.measure()).observe(this.track);
      this.sync();
    }

    // Slides in visual order: the featured (variant) photo is moved to the front with CSS order.
    slides() {
      return [...this.track.children].sort((a, b) => a.offsetLeft - b.offsetLeft);
    }

    current() {
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    go(position) {
      const slides = this.slides();
      const target = slides[Math.max(0, Math.min(position, slides.length - 1))];
      if (target) this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    }

    measure() {
      const media = this.track.querySelector('.gallery__media');
      if (media) this.gallery.style.setProperty('--gallery-media-height', `${media.offsetHeight}px`);
    }

    sync() {
      const slides = this.slides();
      const position = Math.max(0, Math.min(this.current(), slides.length - 1));
      if (this.index) this.index.textContent = position + 1;
      if (this.prev) this.prev.disabled = position === 0;
      if (this.next) this.next.disabled = position >= slides.length - 1;
      const id = slides[position]?.dataset.mediaId;
      this.gallery.querySelectorAll('[data-thumb]').forEach((thumb) => {
        if (thumb.dataset.thumb === id) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }
  }

  // Also after a variant change: the gallery is swapped for the new variant's photos.
  const initGalleries = () => {
    document.querySelectorAll('[data-gallery]:not([data-gallery-ready])').forEach((gallery) => {
      gallery.setAttribute('data-gallery-ready', '');
      new ProductGallery(gallery);
    });
  };
  initGalleries();
  document.addEventListener('pdp:updated', initGalleries);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rte-tables"] && !Shopify.designMode) return;
  try {
    const stackRteTables = () => {
    document.querySelectorAll('.rte table:not(.rte-table--stack)').forEach((table) => {
      const headers = [...table.querySelectorAll('thead th')].map((th) => th.textContent.trim());
      if (headers.length < 2) return;
      table.querySelectorAll('tbody tr').forEach((row) => {
        [...row.children].forEach((cell, index) => {
          if (headers[index]) cell.dataset.label = headers[index];
        });
      });
      table.classList.add('rte-table--stack');
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stackRteTables);
  } else {
    stackRteTables();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.addEventListener('change', (event) => this.onChange(event.target));
    }

    // By option index, not by fieldset order: the condition choice is shown first.
    selectedOptions() {
      const options = [];
      this.querySelectorAll('input:checked, input[data-fixed]').forEach((input) => {
        options[Number(input.dataset.optionIndex)] = input.value;
      });
      return options;
    }

    // Exact match first; otherwise the variant with the chosen value that shares most of the
    // other choices, available ones first (e.g. "Nieuw" exists only as another unit).
    match(options, changed) {
      const exact = this.variants.find((item) => item.options.every((value, index) => value === options[index]));
      if (exact || !changed) return exact;
      const index = Number(changed.dataset.optionIndex);
      const score = (item) => item.options.filter((value, i) => value === options[i]).length + (item.available ? 10 : 0);
      return this.variants
        .filter((item) => item.options[index] === changed.value)
        .sort((a, b) => score(b) - score(a))[0];
    }

    async onChange(changed) {
      const options = this.selectedOptions();
      const variant = this.match(options, changed);
      this.querySelectorAll('[data-option-label]').forEach((label) => {
        label.textContent = options[Number(label.dataset.optionLabel)];
      });
      if (!variant) return;

      const url = `${this.dataset.url}?variant=${variant.id}`;
      window.history.replaceState({}, '', url);
      const section = document.getElementById(`product-${this.dataset.section}`);
      section?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${url}&section_id=${this.dataset.section}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        doc.querySelectorAll('[data-pdp-part]').forEach((next) => {
          const current = document.querySelector(`[data-pdp-part="${next.dataset.pdpPart}"]`);
          if (current) current.replaceWith(next);
        });
        const slide = document.querySelector(`#product-${this.dataset.section} [data-gallery] .gallery__slide--featured`);
        const target = doc.querySelector('.gallery__slide--featured');
        if (target) {
          const thumb = document.querySelector(`[data-thumb="${target.dataset.mediaId}"]`);
          if (thumb) thumb.click();
          else if (slide) slide.scrollIntoView({ block: 'nearest', inline: 'start' });
        }
        document.dispatchEvent(new CustomEvent('pdp:updated', { detail: { variant: variant.id } }));
      } finally {
        section?.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('variant-picker', VariantPicker);
  } catch(e) { console.error(e); }
})();

})();
